export default __webpack_public_path__ + "static/media/battery-25percentage24x24.3d33e12a.svg";